import Mustache from "mustache";
import { Text, View } from '@react-pdf/renderer';
import Html from 'react-pdf-html';

import { useRequest } from '../../../../../store/service/veterinary/useRequest';
import { templatesFunctions } from '../../../../../services/templates/functions';
import { VeterinaryRequestController } from '../../../../../services/controllers/VeterinaryCare';


import { HTMLContentStyle, container, content, title } from './styles';


export function Request() {
  const CLVetRequest = VeterinaryRequestController();

  const requestData = useRequest.getState().data.request.requestData;
  const values = useRequest.getState().data.request.requestValues;

  const fields = {
    ...templatesFunctions.get.partialsFieldsFormat(requestData),
    ...templatesFunctions.get.fieldsFormat(requestData.fields),
  };

  const addBreakLines = templatesFunctions.addBreakLines(values);

  const formattedValues = {
    ...CLVetRequest._defaultRequest,
    ...templatesFunctions.format(fields, addBreakLines),
  };

  const contentData = Mustache.render(requestData.content || '', formattedValues, CLVetRequest._partialsContent)
  const pages = templatesFunctions.splitParagraphs(contentData, 2500).map(page => `${HTMLContentStyle}${page}`)

  return (
    <View style={container} >
      {requestData.title && <Text style={title}>{requestData.title}</Text>}
      {pages.map((page, i) => (
        <View style={content} wrap={false} key={i}>
          <Html >
            {page}
          </Html>
        </View>
      ))}
    </View>
  )
}
